import { AxiosPromise, CancelToken } from 'axios';
import { queryClient } from '../utils/reactQuery';
import { authInstance as instance } from './';

/**
 * requestLogin
 *
 * @description
 * Make a HTTP request for an access token
 */
export function requestLogin(
    username: string,
    password: string,
): AxiosPromise<{ access_token: string }> {
    const data = new URLSearchParams({
        grant_type: 'password',
        client_id: 'webclient',
        username: username,
        password: password,
    });

    return instance.post('/login', data, {
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
        },
    });
}

/**
 * requestRefresh
 *
 * @description
 * Make a HTTP request to refresh an expired JWT
 */
export function requestRefresh(): AxiosPromise<{ access_token: string }> {
    return instance.get('/refresh');
}

/**
 * requestLogout
 *
 * @description
 * Make a HTTP request to clear server-side auth entities
 */
export function requestLogout(cancelToken: CancelToken): AxiosPromise<unknown> {
    queryClient.invalidateQueries();
    return instance.get('/logout', {
        cancelToken: cancelToken,
    });
}
